import { render, staticRenderFns } from "./leaveFormItem.vue?vue&type=template&id=f295efbe&scoped=true"
import script from "./leaveFormItem.vue?vue&type=script&lang=js"
export * from "./leaveFormItem.vue?vue&type=script&lang=js"
import style0 from "./leaveFormItem.vue?vue&type=style&index=0&id=f295efbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f295efbe",
  null
  
)

export default component.exports